export enum RecordingPolicy {
  ALWAYS = "ALWAYS",
  MANUAL = "MANUAL",
  NEVER = "NEVER",
}

export const RECORDING_POLICY_OPTIONS = [
  { value: RecordingPolicy.ALWAYS, label: "Always record" },
  { value: RecordingPolicy.MANUAL, label: "Agent controlled" },
  { value: RecordingPolicy.NEVER, label: "Never record" },
];
